<template>
  <!-- 投放计划页面 -->
  <!-- 页头 -->
  <div class="launch">
    <!-- 顶部操作 -->
    <header>
      <div class="header-left">
        <el-row>
          <el-popover
            placement="bottom"
            width="200"
            trigger="hover"
          >
            <div class="creates">
              <div class="create">
                <div style="font-size: 16px;margin-bottom: 5px;">新版创建</div>
                <div style="color: silver">支持视频号推广目标</div>
              </div>
              <div class="create" style="margin-top: 20px">
                <div style="font-size: 16px;margin-bottom: 5px;" @click="$router.push({path: '/createEdition'})">旧版创建</div>
                <div style="color: silver">使用原版流程创建</div>
              </div>
            </div>
            <el-button slot="reference" type="success" icon="el-icon-plus">创建投放计划</el-button>
          </el-popover>
          <span>实时数据仅供参考，请以前一日数据为准。</span>
        </el-row>
      </div>
      <div class="header-right">
        <div>
          <span>数据日期</span>
          <span class="time">2021-11-26-2021-11-26</span>
          <i class="el-icon-date" />
        </div>
        <div class="operate">
          <span>自定义列<i class="el-icon-caret-bottom" /></span>
          <span><i class="el-icon-s-platform" />托管助手</span>
          <span><i class="el-icon-download" />下载</span>
        </div>
      </div>
    </header>
    <!-- 搜索和添加筛选的操作-->
    <nav>
      <div class="nav">
        <!--  筛选组件-->
        <LaunchFilter />
        <el-input v-model="input" prefix-icon="el-icon-search" placeholder="搜索投放计划" />
        <div class="filtrate">创建日期：最近三个月</div>
        <div class="filtrate">状态：全部</div>
        <div class="add">
          <i class="el-icon-circle-plus-outline" />
          <span>添加筛选条件</span>
        </div>
      </div>
    </nav>
    <!-- 主要内容-->
    <el-table :data="tableData.list" border highlight-current-row stripe style="width: 100%">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="campaign_name" label="投放计划名称" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.campaign_name }}</span>
          <LaunchTime label="计划日预算">
            <div>
              <div class="budget">
                <el-radio v-model="radio" label="1">不限预算</el-radio>
                <el-radio v-model="radio" label="2">指定预算</el-radio>
              </div>
              <div class="budget">
                <el-input v-model="input" size="mini" placeholder="请输入内容" />
                <span>元/天</span>
              </div>
              <div class="budget">
                <span>每日预算1.000元~</span>
                <span>50.000.000元/天</span>
              </div>
            </div>
          </LaunchTime>
        </template>
      </el-table-column>
      <el-table-column prop="configured_status" label="状态" min-width="100" />
      <el-table-column prop="address1" label="操作" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.address1 }}</span>
          <LaunchOperate />
        </template>
      </el-table-column>
      <el-table-column prop="address2" label="创意预览" min-width="100">
        <template>
          <IdeasPreviewPopout />
        </template>
      </el-table-column>
      <el-table-column prop="add123" label="曝光评估" sortable min-width="120" />
      <el-table-column prop="created_time" label="投放时间" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.created_time }}</span>
          <LaunchTime label="修改投放时间">
            <main>
              <div class="selection">
                <div class="date-selection">投放日期<i class="el-icon-question" /></div>
                <div>
                  <el-radio v-model="radio" label="1">选择开始和结束日期</el-radio>
                  <el-radio v-model="radio" label="2">长期投放<i class="el-icon-question" /></el-radio>
                </div>
              </div>
              <div class="selection">
                <span class="date-selection">开始时间与结束日期</span>
                <el-date-picker
                  v-model="value"
                  type="daterange"
                  size="mini"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                />
              </div>
              <div class="selection">
                <div class="date-selection">投放时段<i class="el-icon-question" /></div>
                <div>
                  <el-radio v-model="period" label="1">全体投放</el-radio>
                  <el-radio v-model="period" label="2">每日相同时间投放</el-radio>
                  <el-radio v-model="period" label="3">自定义投放</el-radio>
                </div>
              </div>
              <div class="selection">
                <div class="date-selection">每日投放时段</div>
                <el-time-picker
                  v-model="value1"
                  is-range
                  size="mini"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                />
              </div>
            </main>
          </LaunchTime>
        </template>
      </el-table-column>
      <el-table-column prop="promoted_object_type" label="推广目标" min-width="120" />
      <el-table-column prop="address6" label="购买类型" min-width="120" />
      <el-table-column prop="total_budget" label="广告预算(元)" min-width="120" />
      <el-table-column prop="address8" label="计划预算(元)" min-width="120" />
      <el-table-column prop="address9" label="花费(元)" sortable min-width="100" />
      <el-table-column prop="addressa" label="曝光次数" sortable min-width="120" />
      <el-table-column prop="addressb" label="点击次数" sortable min-width="120" />
      <el-table-column prop="addresss" label="点击率" sortable min-width="100" />
      <el-table-column prop="addressd" label="转化目标量" sortable min-width="120" />
      <el-table-column prop="addresse" label="转化目标成本(元)" sortable min-width="150" />
      <el-table-column prop="addressf" label="目标转化率" sortable min-width="120" />
    </el-table>
    <!-- 分页 -->
    <pagination-right :scroll="true" :total="query.total" @size-change="fetchPageSize" @current-change="fetchCurrentPage" />
  </div>
</template>

<script>
// 引入
import IdeasPreviewPopout from '@/components/Advertising/launchManagement/IdeasPreviewPopout'
import LaunchTime from '@/components/Advertising/launchManagement/LaunchTime'
import LaunchOperate from '@/components/Advertising/launchManagement/LaunchOperate'
// import LaunchTab from '@/components/Advertising/launchManagement/LaunchTab'
import LaunchFilter from '@/components/Advertising/launchManagement/LaunchFilter'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getAdvertList } from '@/api/advertManage'
// import enumerateObj from '@/utils/searchEnumerate/extension'
// import { getFormtTime } from '@/utils/dateFormat/dateFormat'
import moment from 'moment'
import { apiNameIn, apiNameInFilter } from '@/api/enumeration'
export default {
  name: 'Launch',
  components: { LaunchFilter, PaginationRight, LaunchOperate, LaunchTime, IdeasPreviewPopout },
  // 定义数据
  data() {
    return {
      // 获取推广计划的请求参数
      advertListQuery: {
        account_id: null,
        page: 1,
        page_size: 10,
        filtering: null
      },
      // 根据api名称获取参数枚举值的请求参数
      apiNameInQuery: {
        account_id: null,
        api_name: 'campaigns/get'
      },
      total: null,
      value: '',
      input: '',
      period: '',
      value1: '',
      radio: '',
      tableData: [], // 存放后台返回数据
      // 请求相关
      query: {
        userId: '', // 查询的ID
        fileds: [
          { 'field': '', 'operator': 'EQUALS', 'values': [] }
        ], // 过滤条件
        page: '1', // 当前页码
        pageSize: '10', // 显示数据条数
        isDeleted: false, // 是否已删除
        total: 0 // 数据总条数
      },
      // 筛选条件
      screenCon: {},
      enList: {} // 用于存放请求回来的枚举值
    }
  },
  created() {
    this.getList()
    this.getEnLsit()
    this.getEnFilter()
  },
  methods: {
    // 获取推广计划
    getList() {
      this.advertListQuery.account_id = this.apiNameInQuery.account_id = this.$route.query.account_id
      getAdvertList(this.advertListQuery).then(res => {
        this.tableData = res.data
        this.query.total = res.data.count
        this.isEnumeration()
        this.dateFmt()
      })
    },
    // 筛选对应的枚举值
    isEnumeration() {
      for (let i = 0; i < this.tableData.list.length; i++) {
        this.tableData.list[i].campaign_type = this.enList.campaign_type[this.tableData.list[i].campaign_type]
        this.tableData.list[i].configured_status = this.enList.configured_status[this.tableData.list[i].configured_status]
        this.tableData.list[i].promoted_object_type = this.enList.promoted_object_type[this.tableData.list[i].promoted_object_type]
      }
    },
    // 格式化日期
    dateFmt() {
      for (let i = 0; i < this.tableData.list.length; i++) {
        this.tableData.list[i].created_time = moment(this.tableData.list[i].created_time).format('YYY-MM-DD HH:mm:ss')
        this.tableData.list[i].last_modified_time = moment(this.tableData.list[i].last_modified_time).format('YYY-MM-DD HH:mm:ss')
      }
      console.log(this.tableData.list[1].created_time)
    },
    // 获取枚举值
    getEnLsit() {
      apiNameIn(this.apiNameInQuery).then(res => {
        res.data.forEach(item => {
          this.enList[item.params_name] = { ...item.content }
        })
      })
    },
    getEnFilter() {
      apiNameInFilter(this.apiNameInQuery).then(res => {
        // 获取对应的筛选条件
        this.screenCon = res.data[0].content
        this.isEnumeration()
        console.log('enfilter', res.data[0].content)
        console.log('screenCon', this.screenCon)
      })
    },
    fetchPageSize(data) {
      this.query.pageSize = data
      console.log(data)
      this.getList()
    },
    fetchCurrentPage(data) {
      this.query.page = data
      this.getList()
    }
  }
}

</script>

<style scoped lang="less">
  .launch {
    min-width: 1200px;
    /deep/ .el-input--mini {
      width: 80%;
    }
    /deep/ .el-dialog__body {
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #EBEEF5;
      border-top: 1px solid #EBEEF5;
    }
    /deep/ .dialog-footer {
      display: flex;
      justify-content: center;
    }
    main {
      padding: 20px 0 20px 30px;
      .selection {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
        .date-selection {
          margin-right: 20px;
        }
      }
    }
    .budget {
      margin-top: 10px;
    }
    header {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 20px 5px 20px;
      color: silver;
      .header-left {
        .creates {
          padding: 10px;
        }
        .el-button {
          width: 150px;
          height: 40px;
        }
        span {
          margin-left: 10px;
          font-weight: 300;
        }
      }
      .header-right {
        display: flex;
        align-items: center;
        .time {
          color: #333333;
          margin: 0 10px 0 10px;
        }
        .operate {
          color: #333333;
          margin-left: 20px;
          padding: 15px 0 15px 20px;
          border-left: 1px solid #EBEEF5;
        }
      }
    }
    nav {
      border-top: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
      padding: 10px 20px 10px 20px;
      .nav {
        display: flex;
        align-items: center;
        .el-input {
          width: 140px;
        }
        /deep/ .el-input__inner {
          width: 130px;
          border-radius: 20px;
          margin-left: 10px;
        }
        /deep/ .el-input__prefix {
          margin-left: 10px;
        }
        .filtrate {
          padding: 10px 20px;
          border-radius: 30px;
          background-color: rgb(253,253,253);
          border: 1px solid #EBEEF5;
          margin-left: 10px;
        }
        .add {
          margin-left: 10px;
          color: silver;
        }
      }
    }
  }
</style>
